export const SUPER_ADMIN = "super admin";
export const ADMIN = "admin";
export const ACCOUNTANT = "accountant";
export const EMPLOYEE = "employee";
export const CORPORATION_OWNER = "corporation owner";
export const COMMUNITY_MANAGER = "community manager";
export const COMMUNITY_ACCOUNTANT = "community accountant";
export const MAIN_ROLES = [SUPER_ADMIN, ADMIN, ACCOUNTANT, EMPLOYEE];
export const CLIENT_ROLES = [
    CORPORATION_OWNER,
    COMMUNITY_MANAGER,
    COMMUNITY_ACCOUNTANT
];
